<template>
  <div id="content-wrapper">
    <ButtonBar
      :isEdit="isEdit"
      :isView="isView"
      :disabled="isLoading"
      @onLuu="onLuu"
      @onReset="onReset"
    />
    <validation-observer ref="obCanBo">
      <b-form class="font-size-14">
        <b-row>
          <b-col
            class="center"
            cols="4"
            v-if="
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG &&
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG
            "
          >
            <BaseUploadImage
              class="p-2"
              :isDisabled="isView"
              :image="form.anhDaiDien_FilePath"
              @input="
                upLoadFileToServer(
                  $event,
                  imageType.anhDaiDien,
                  'anhDaiDien_FilePath'
                )
              "
              label="Ảnh đại diện"
            />
          </b-col>
          <b-col
            class="center"
            cols="4"
            v-if="
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG &&
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG
            "
          >
            <BaseUploadImage
              class="p-2"
              :isDisabled="isView"
              :image="form.anhChuKy_FilePath"
              @input="
                upLoadFileToServer(
                  $event,
                  imageType.anhChuKy,
                  'anhChuKy_FilePath'
                )
              "
              label="Ảnh chữ ký cá nhân"
            />
          </b-col>
          <b-col
            class="center"
            cols="4"
            v-if="
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG &&
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG
            "
          >
            <BaseUploadImage
              class="p-2"
              :isDisabled="isView"
              :image="form.anhChuKyNhay_FilePath"
              @input="
                upLoadFileToServer(
                  $event,
                  imageType.anhChuKyNhay,
                  'anhChuKyNhay_FilePath'
                )
              "
              label="Ảnh chữ ký đơn vị"
            />
          </b-col>
          <b-col cols="4">
            <ValidationProvider
              name="Tên cán bộ"
              rules="required"
              v-slot="validationContext"
            >
              <b-form-group label="Họ và tên" class="required">
                <b-form-input
                  :disabled="isView"
                  :state="getValidationState(validationContext)"
                  id="hoTen"
                  v-model="form.hoTen"
                ></b-form-input>
                <b-form-invalid-feedback
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col cols="4">
              <b-form-group label="Mã cán bộ">
                <b-form-input
                  :disabled="isView"
                  id="hoTen"
                  v-model="form.maCanBo"
                ></b-form-input>
              </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Thứ tự" label-for="thuTu">
              <b-form-input
                :disabled="isView"
                id="thuTu"
                v-model="form.thuTu"
                type="number"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Ngày sinh" label-for="ngaySinh">
              <date-picker
                required
                format="DD/MM/YYYY"
                value-type="format"
                type="day"
                :disabled="isView"
                v-model="ngaySinhFormatted"
                class="custom-datepicker"
                placeholder="Chọn ngày"
                :disabled-date="(e) => minDate(e)"
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Số CMND" label-for="cmtnd">
              <b-form-input
                type="number"
                :disabled="isView"
                id="cmtnd"
                v-model="form.cmtnd"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Ngày cấp CMND" label-for="nccmtnd">
              <date-picker
                required
                format="DD/MM/YYYY"
                value-type="format"
                type="day"
                :disabled="isView"
                v-model="form.ngayCapCMTND"
                class="custom-datepicker"
                placeholder="Chọn ngày"
                :disabled-date="(e) => minDate(e)"
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Giới tính">
              <v-select
                ref="gioiTinh"
                :multiple="false"
                v-model="form.gioiTinh"
                :options="optionsGender"
                required
                :disabled="isView"
                :reduce="(name) => name.value"
                title="Chọn giới tính"
                placeholder="Chọn giới tính"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Số CCCD" label-for="cmtnd">
              <b-form-input
                type="number"
                :disabled="isView"
                id="cmtnd"
                v-model="form.cccd"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Ngày cấp CCCD" label-for="nccccd">
              <date-picker
                required
                format="DD/MM/YYYY"
                value-type="format"
                type="day"
                :disabled="isView"
                v-model="form.ngayCapCCCD"
                class="custom-datepicker"
                placeholder="Chọn ngày"
                :disabled-date="(e) => minDate(e)"
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <ValidationProvider
              name="Số sim CA"
              rules="phone_number:8,20"
              v-slot="validationContext"
            >
              <b-form-group label="Số sim CA" label-for="cA_Number">
                <b-form-input
                  type="text"
                  :state="getValidationState(validationContext)"
                  id="cA_Number"
                  :disabled="isView"
                  v-model="form.cA_Number"
                ></b-form-input>
                <b-form-invalid-feedback
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col cols="4">
            <ValidationProvider
              name="Số di động cơ quan"
              rules="phone_number:8,20"
              v-slot="validationContext"
            >
              <b-form-group
                label="Số điện thoại cơ quan"
                label-for="phone_CoQuan"
              >
                <b-form-input
                  type="text"
                  :state="getValidationState(validationContext)"
                  id="phone_CoQuan"
                  :disabled="isView"
                  v-model="form.phone_CoQuan"
                ></b-form-input>
                <b-form-invalid-feedback
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col cols="4">
            <ValidationProvider
              name="Số di động cơ quan"
              rules="phone_number:8,20"
              v-slot="validationContext"
            >
              <b-form-group label="Số điện thoại" label-for="phone_DiDong">
                <b-form-input
                  type="text"
                  :state="getValidationState(validationContext)"
                  id="phone_DiDong"
                  :disabled="isView"
                  v-model="form.phone_DiDong"
                ></b-form-input>
                <b-form-invalid-feedback
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col cols="4">
            <ValidationProvider
              name="Email"
              rules="email|required"
              v-slot="validationContext"
            >
              <b-form-group label="Email" label-for="taocanbo" class="required">
                <b-form-input
                  type="email"
                  :state="getValidationState(validationContext)"
                  id="phone_DiDong"
                  :disabled="isView"
                  v-model="form.email"
                ></b-form-input>
                <b-form-invalid-feedback
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider></b-col
          >
          <b-col cols="8">
            <b-form-group label="Địa chỉ liên hệ">
              <b-form-input
                id="hoTen"
                :disabled="isView"
                v-model="form.diaChi"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Tỉnh/TP">
              <b-form-select
                v-model="form.tinhThanh"
                :options="listTinhThanh"
                class="mb-3"
                value-field="id"
                text-field="name"
                :disabled="isView"
                @change="loadHuyen"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Quận/huyện">
              <b-form-select
                :key="showHuyen"
                v-model="form.quanHuyen"
                :options="listQuanHuyen"
                class="mb-3"
                value-field="id"
                text-field="name"
                @change="loadXa"
                :disabled="!form.tinhThanh || isView"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Phường/xã">
              <b-form-select
                :key="showXa"
                v-model="form.phuongXa"
                :options="listPhuongXa"
                class="mb-3"
                value-field="id"
                text-field="name"
                :disabled="!form.quanHuyen || isView"
              ></b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group label="Trụ sở">
              <b-form-select
                v-model="form.headquarterId"
                :options="listTruSo"
                class="mb-3"
                value-field="id"
                text-field="headquarterName"
                :disabled="isView"
                @change="loadToaNha"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Tòa nhà">
              <b-form-select
                v-model="form.buildingId"
                :options="listToaNha"
                class="mb-3"
                value-field="id"
                text-field="buildingName"
                @change="loadXa"
                :disabled="!form.headquarterId || isView"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
              <b-form-group label="Mã thẻ" >
                <b-form-input
                  :disabled="isView"
                  id="hoTen"
                  v-model="form.maThe"
                ></b-form-input>
              </b-form-group>
          </b-col>

          <b-col
            cols="6"
            v-if="
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG &&
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG
            "
          >
            <b-form-group label="">
              <div class="mt-sm-2">
                <span class="mr-4">Hình thức nhận tin buồn</span>
                <b-form-checkbox
                  id="bit_NhanTinBuon_SMS"
                  inline
                  :disabled="isView"
                  v-model="form.bit_NhanTinBuon_SMS"
                  >SMS
                </b-form-checkbox>
                <b-form-checkbox
                  id="bit_NhanTinBuon_Email"
                  inline
                  :disabled="isView"
                  v-model="form.bit_NhanTinBuon_Email"
                  >Email
                </b-form-checkbox>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="3" v-if="false">
            <b-form-group label-align-sm="right" label-cols-sm="3"
              ><div class="mt-sm-2">
                <b-form-checkbox
                  id="bit_ThuTruongDonVi"
                  inline
                  :disabled="isView"
                  v-model="form.bit_ThuTruongDonVi"
                  >Lãnh đạo đơn vị
                </b-form-checkbox>
              </div></b-form-group
            >
          </b-col>
          <b-col cols="3" class="d-flex mt-sm-2">
            <span> Trạng thái khóa cán bộ </span>
            <b-form-checkbox
              class="cursor-pointer"
              style="padding-left: 3.25rem"
              :checked="form.lockoutEnabled"
              :disabled="isView"
              switch
              v-model="form.lockoutEnabled"
            ></b-form-checkbox>
          </b-col>
          <b-col cols="3" class="d-flex mt-sm-2">
            <span> Hiển thị danh bạ </span>
            <b-form-checkbox
              class="cursor-pointer"
              style="padding-left: 3.25rem"
              :checked="form.bit_DanhBa"
              :disabled="isView"
              switch
              v-model="form.bit_DanhBa"
            ></b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            v-if="
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG &&
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG
            "
          >
            <span class="float-left mr-3 mt-1">Đơn vị</span
            ><base-button
              v-if="!isView"
              @click="themDonVi"
              class="float-left"
              icon="none"
              color="btn-primary"
              button="Thêm đơn vị"
            />
          </b-col>
          <b-col
            cols="12"
            v-if="
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG &&
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG
            "
          >
            <DataTable
              :key="keyTablePhamVi"
              :value="filterList(form.donViList || [])"
              class="p-datatable-customers mt-2"
              dataKey="Id"
              :paginator="false"
              v-if="isShowCanBoTable"
              :auto-layout="true"
            >
              <template #empty
                ><div class="text-center">Không có dữ liệu</div></template
              >
              <template #loading>Đang tải dữ liệu ...</template>
              <Column
                v-for="(col, index) in MANG_DON_VI_FIELDS"
                :key="index"
                :field="col.field"
                :header="col.header"
                :header-class="col.headerClass"
                :header-style="col.headerStyle"
                :body-class="col.bodyClass"
              >
                <template #filter>
                  <InputText
                    v-if="col.keySearch"
                    type="text"
                    class="p-column-filter"
                    placeholder="Tìm kiếm"
                    v-model="form[col.keySearch]"
                    @keyup.enter="
                      searchTable(form[col.keySearch], col.field, 'donViList')
                    "
                  />
                </template>
                <template v-if="col.field === 'Stt'" #body="slotProps">
                  {{ slotProps.index + 1 }}
                </template>
                <template v-else-if="col.field === 'donVi'" #body="slotProps">
                  {{ slotProps.data.donVi.labelName ? slotProps.data.donVi.labelName : slotProps.data.donVi.label }}
                </template>
                <template v-else-if="col.field === 'chucVu'" #body="slotProps">
                  {{ slotProps.data.chucVu.chucVu }}
                </template>
                <template
                  v-else-if="col.field === 'trangThai'"
                  #body="slotProps"
                >
                  {{ slotProps.data.trangThai.name }}
                </template>
                <template
                  v-else-if="col.field === 'bit_LanhDaoDonVi'"
                  #body="slotProps"
                >
                  <b-form-checkbox
                    :disabled="isView"
                    class="text-center cursor-pointer"
                    :checked="slotProps.data.bit_LanhDaoDonVi"
                    switch
                    v-model="slotProps.data.bit_LanhDaoDonVi"
                  ></b-form-checkbox>
                </template>
                <template v-else-if="col.field === 'macDinh'" #body="slotProps">
                  <b-form-checkbox
                    :disabled="isView"
                    class="text-center cursor-pointer"
                    :checked="slotProps.data.macDinh"
                    switch
                    @change="
                      changeSwitch(slotProps.data.macDinh, slotProps.index)
                    "
                    v-model="slotProps.data.macDinh"
                  ></b-form-checkbox>
                </template>
                <template v-else-if="col.field === 'isShowTreeCCTC'" #body="slotProps">
                  <b-form-checkbox
                    :disabled="isView"
                    class="text-center cursor-pointer"
                    :checked="slotProps.data.isShowTreeCCTC"
                    switch
                    v-model="slotProps.data.isShowTreeCCTC"
                  ></b-form-checkbox>
                </template>
                <template
                  v-else-if="col.field === 'thaoTac' && !isView"
                  #body="slotProps"
                >
                  <b-icon
                    icon="pencil-square"
                    class="cursor-pointer mr-2"
                    @click="onEditDonVi(slotProps.data, slotProps.index)"
                  />
                  <b-icon
                    icon="trash"
                    class="cursor-pointer"
                    @click="
                      openModalConfirm(
                        slotProps.index,
                        1,
                        slotProps.data.donVi.label
                      )
                    "
                  />
                </template>
              </Column>
            </DataTable>
          </b-col>
          <b-col
            cols="12"
            class="mt-3"
            v-if="
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG &&
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG
            "
          >
            <span class="float-left mr-3 mt-1">Thông tin tài khoản</span>
            <base-button
              v-if="!isView"
              class="float-left"
              button="Chọn tài khoản"
              @click="chonThongTinTaiKhoan"
            />
            <base-button
              v-if="!isView"
              class="float-left"
              button="Thêm mới tài khoản"
              icon="none"
              color="btn-primary"
              @click="themThongTinTaiKhoan"
            />
          </b-col>
          <b-col
            cols="12"
            v-if="
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG &&
              this.$router.currentRoute.name !==
                this.ROUTE.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG
            "
          >
            <DataTable
              :value="filterList(form.thongTinTaiKhoan || [])"
              class="p-datatable-customers mt-2"
              v-if="isShowTaiKhoanTable"
              dataKey="Id"
              :paginator="false"
              :auto-layout="true"
            >
              <template #empty
                ><div class="text-center">Không có dữ liệu</div></template
              >
              <template #loading>Đang tải dữ liệu ...</template>
              <Column
                v-for="(col, index) in MANG_THONG_TIN_TAI_KHOAN_FIELDS"
                :key="index"
                :field="col.field"
                :header="col.header"
                :header-class="col.headerClass"
                :body-class="col.bodyClass"
              >
                <template #filter>
                  <InputText
                    v-if="col.keySearch"
                    type="text"
                    class="p-column-filter"
                    placeholder="Tìm kiếm"
                    v-model="form[col.keySearch]"
                    @keyup.enter="
                      searchTable(
                        form[col.keySearch],
                        col.field,
                        'thongTinTaiKhoan'
                      )
                    "
                  />
                </template>
                <template v-if="col.field === 'Stt'" #body="slotProps">
                  {{ slotProps.index + 1 }}
                </template>
                <template
                  v-else-if="col.field === 'tenDangNhap'"
                  #body="slotProps"
                >
                  {{ slotProps.data.tenDangNhap.userName }}
                </template>
                <template v-else-if="col.field === 'ungDung'" #body="slotProps">
                  <div
                    v-for="(item, index) in slotProps.data.ungDung"
                    :key="index"
                  >
                    {{ item.name }}
                  </div>
                </template>
                <template
                  v-else-if="col.field === 'trangThai'"
                  #body="slotProps"
                >
                  {{ slotProps.data.trangThai.name }}
                </template>
                <template
                  v-else-if="col.field === 'thaoTac' && !isView"
                  #body="slotProps"
                >
                  <b-icon
                    icon="pencil-square"
                    class="cursor-pointer mr-2"
                    @click="onEditThongTin(slotProps.data, slotProps.index)"
                  />
                  <b-icon
                    icon="trash"
                    class="cursor-pointer"
                    @click="
                      openModalConfirm(
                        slotProps.index,
                        2,
                        slotProps.data.tenDangNhap.userName
                      )
                    "
                  />
                </template>
              </Column>
            </DataTable>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <ButtonBar
      :isEdit="isEdit"
      :isView="isView"
      :disabled="isLoading"
      @onLuu="onLuu"
      @onReset="onReset"
    />
    <ModalTaoChucVu :is-edit="false" ref="modalCapNhatChucVu" />
    <ModalThemThongTinDonVi
      ref="ModalThemThongTinDonVi"
      :reload="isLoad"
      :danhSachDonViBanDau="danhSachDonViBanDau"
      :data="dataDonVi"
      :normalizer="normalizer"
      @onSave="themDonViItem"
      @onEdit="suaDonViItem"
    />
    <ModalThemThongTinTaiKhoan
      ref="ModalThemThongTinTaiKhoan"
      :data="dataDonVi"
      :reload="isLoad"
      :isChoose="isChooseTaiKhoan"
      @onSave="themThongTinItem"
      @onEdit="suaThongTinItem"
    />
    <ModalConfirm ref="ModalConfirm" :name="labelDelete" @onDelete="onDelete" />
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { HUY_BO_BUTTON_LABEL, ROUTE_NAME } from "@/constants/constants";
import {
  MANG_DON_VI_FIELDS,
  MANG_THONG_TIN_TAI_KHOAN_FIELDS,
} from "@/constants/donVi";
import _cloneDeep from "lodash/cloneDeep";
import { removeAccents } from "@/utils/normalize";
import ModalTaoChucVu from "@/components/pages/quan-tri-he-thong/chuc-vu/modalCapNhatChucVu";
import ModalThemThongTinDonVi from "@/components/pages/quan-ly-danh-muc/don-vi/ModalThemThongTinDonVi";
import ModalThemThongTinTaiKhoan from "@/components/pages/quan-ly-danh-muc/don-vi/ModalThemThongTinTaiKhoan";
import ModalConfirm from "@/components/pages/quan-ly-danh-muc/don-vi/ModalConfirm";
import ButtonBar from "@/components/pages/quan-ly-danh-muc/can-bo/ButtonBar";
import BaseUploadImage from "@/components/common/BaseUploadImage";
import { isNil, pickBy } from "lodash";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _isEmpty from "lodash/isEmpty";

export default {
  name: "TaoCanBo",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModalTaoChucVu,
    BaseUploadImage,
    DatePicker,
    ModalThemThongTinDonVi,
    ModalThemThongTinTaiKhoan,
    ModalConfirm,
    ButtonBar,
  },
  data() {
    return {
      anhDaiDien_FilePath: null,
      anhChuKy_FilePath: null,
      anhChuKyNhay_FilePath: null,
      keyTablePhamVi: 0,
      isLoad: false,
      ROUTE: ROUTE_NAME,
      HUY_BO_BUTTON_LABEL: HUY_BO_BUTTON_LABEL,
      ngaySinhFormatted: null,
      listTinhThanh: [],
      listQuanHuyen: [],
      listPhuongXa: [],
      listTruSo: [],
      listToaNha: [],
      dataDonVi: null,
      isShowCanBoTable: true,
      isShowTaiKhoanTable: true,
      indexSua: 0,
      typeXoa: 1,
      labelDelete: "",
      showHuyen: true,
      showXa: true,
      isLoading: false,
      isChooseTaiKhoan: false,
      MANG_DON_VI_FIELDS: this.formatColumn(MANG_DON_VI_FIELDS),
      MANG_THONG_TIN_TAI_KHOAN_FIELDS: this.formatColumn(
        MANG_THONG_TIN_TAI_KHOAN_FIELDS
      ),
      form: {
        donViList: [],
        thongTinTaiKhoan: [],
        userId: null,
        tinhThanh: null,
        quanHuyen: null,
        phuongXa: null,
        maCanBo: "",
        hoTen: "",
        cA_Number: "",
        phone_DiDong: "",
        phone_CoQuan: "",
        phone_NhaRieng: "",
        email: "",
        gioiTinh: null,
        ngaySinh: null,
        iD_ChucVu: null,
        userName: "",
        iD_DonVi: null,
        iD_DonVi_HoatDong: null,
        iD_DonVi_BietPhai: null,
        cmtnd: "",
        diaChi: "",
        bit_ChuyenCongTac: false,
        bit_NhanTinBuon_Email: false,
        bit_NhanTinBuon_SMS: false,
        bit_DanhBa: false,
        bit_ThuTruongDonVi: false,
        bitDauMoiPAKN: false,
        anhDaiDien_FilePath: "",
        anhChuKy_FilePath: "",
        anhChuKyNhay_FilePath: "",
        thuTu: null,
        lockoutEnabled: false,
        headquarterId: null,
        buildingId: null,
        ngayCapCCCD: null,
        ngayCapCMTND: null,
        cccd: null,
        maThe: null,
      },
      imageType: {
        anhDaiDien: 1,
        anhChuKy: 2,
        anhChuKyNhay: 3,
      },
      optionsGender: [
        { label: "Nữ", value: false },
        { label: "Nam", value: true },
      ],
      optionsDonVi: [],
      optionsDonViBietPhai: [],
      reloadDonVI: false,
      reloadDonVIBietPhai: false,
      danhSachNguoiDung: [],
    };
  },
  computed: {
    ...mapGetters({
      chiTietCanBo: "canBo/canBo",
      danhSachChucVu: "chucVu/danhSachChucVu",
      dsDonViCon: "donVi/danhSachDonViCon",
      danhSachDonViPhanTrang: "donVi/danhSachDonViPhanTrang",
      danhSachDonVi: "donVi/danhSachDonVi",
    }),
    danhSachDonViBanDau() {
      if (!this.danhSachDonVi) {
        return [];
      }
      let danhSach = [];
      danhSach = this.danhSachDonVi.map((item) => {
        return {
          Task_ID: item.id,
          Task_Parent_ID: item.iD_DonVi_Cha,
          Label: item.tenDonVi,
          Childrens: [],
          ...item,
        };
      });
      return this.list_to_tree(danhSach);
    },
  },
  async created() {
    this.layDiaChi();
    if (this.isEdit) {
      await this.layChiTietCanBo();
    }
    await this.$store.dispatch("donVi/layDanhSachDonViCha", {}).then(() => {});
    this.layDanhSachChucVu();
    this.layNguoiDungKhongThuocCanBo();
  },
  methods: {
    searchTable(value, col, list) {
      if (list == "thongTinTaiKhoan") {
        this.isShowTaiKhoanTable = false;
      } else {
        this.isShowCanBoTable = false;
      }
      this.form[list].forEach((item) => {
        if (
          this.removeAccents(item[col].name, true).includes(
            this.removeAccents(value, true)
          ) ||
          this.removeAccents(item[col].userName, true).includes(
            this.removeAccents(value, true)
          ) ||
          this.removeAccents(item[col].label, true).includes(
            this.removeAccents(value, true)
          ) ||
          this.removeAccents(item[col].chucVu, true).includes(
            this.removeAccents(value, true)
          ) ||
          (Array.isArray(item[col]) &&
            this.removeAccents(item[col][0].name, true).includes(
              this.removeAccents(value, true)
            ))
        ) {
          item.isHide = false;
        } else {
          item.isHide = true;
        }
      });
      if (list == "thongTinTaiKhoan") {
        this.isShowTaiKhoanTable = true;
      } else {
        this.isShowCanBoTable = true;
      }
    },
    filterList(list) {
      return list.filter((key) => !key.isHide);
    },
    async loadDiaChi() {
      if (!this.form.tinhThanh) {
        this.form.quanHuyen = null;
      } else {
        await this.layDiaChi(this.form.tinhThanh, "listQuanHuyen");
        this.form.quanHuyen = this.listQuanHuyen[0].id;
      }
      if (!this.form.quanHuyen) {
        this.form.phuongXa = null;
      } else {
        await this.layDiaChi(this.form.quanHuyen, "listPhuongXa");
        this.form.phuongXa = this.listPhuongXa[0].id;
      }
    },
    loadTruSo(data) {
      this.$store.dispatch('canBo/getTruSo', {}).then((res) => {
        this.listTruSo = res.data
        if(data && data.headquarterId) {
          this.listToaNha = res.data.find((item) => item.id === data.headquarterId).listBuilding || []
        }
      })
    },
    removeAccents(string, upperCase = false) {
      return removeAccents(string, upperCase);
    },
    formatColumn(list) {
      let formatList = _cloneDeep(list);
      if (this.isView) formatList.pop();
      return formatList;
    },
    getPayload() {
      let departments = [];
      this.form.donViList.forEach((item) => {
        departments.push({
          id: item.id,
          chucVuId: item.chucVu.id,
          tenChucVu: item.chucVu.chucVu,
          tenChucVuKhongDau: this.removeAccents(item.chucVu.chucVu),
          donViId: (item.donVi || {}).id,
          tenDonVi: (item.donVi || {}).label,
          tenDonViKhongDau: this.removeAccents(item.donVi.label),
          trangThai: item.trangThai.id ? 1 : 0,
          isDefault: item.macDinh,
          isShowTreeCCTC: item.isShowTreeCCTC,
          bit_LanhDaoDonVi: item.bit_LanhDaoDonVi,
        });
      });
      let userAccounts = [];
      this.form.thongTinTaiKhoan.forEach((item) => {
        let application = [];
        item.ungDung.forEach((i) => {
          application.push({
            applicationName: i.name,
            applicationNameKhongDau: this.removeAccents(i.name),
            applicationId: i.id,
          });
        });
        userAccounts.push({
          id: item.tenDangNhap.id || null,
          userId: item.tenDangNhap.userId,
          username: item.tenDangNhap.userName,
          applications: application,
          password: item.matKhau,
          trangThai: item.trangThai.id ? 1 : 0,
        });
      });
      return {
        id: this.$route.params.id,
        maCanBo: this.form.maCanBo,
        hoTen: this.form.hoTen,
        cA_Number: this.form.cA_Number,
        phone_DiDong: this.form.phone_DiDong,
        phone_CoQuan: this.form.phone_CoQuan,
        phone_NhaRieng: this.form.phone_NhaRieng,
        email: this.form.email,
        gioiTinh: this.form.gioiTinh,
        ngaySinh: moment(
          new Date(this.convertStringToDateTime(this.ngaySinhFormatted))
        ).toISOString(),
        iD_ChucVu: null,
        userName: "",
        iD_DonVi: null,
        iD_DonVi_HoatDong: null,
        iD_DonVi_BietPhai: null,
        cmtnd: this.form.cmtnd,
        bit_NhanTinBuon_Email: this.form.bit_NhanTinBuon_Email,
        bit_NhanTinBuon_SMS: this.form.bit_NhanTinBuon_SMS,
        bit_ThuTruongDonVi: this.form.bit_ThuTruongDonVi,
        diaChi: this.form.diaChi,
        userId: null,
        thuTu: this.form.thuTu,
        tinhId: this.form.tinhThanh,
        huyenId: this.form.quanHuyen,
        xaId: this.form.phuongXa,
        userAccounts: userAccounts,
        departments: departments,
        anhDaiDien_FilePath: this.anhDaiDien_FilePath ? this.anhDaiDien_FilePath : this.$route.params.id ? this.chiTietCanBo.anhDaiDien_FilePath : '',
        anhChuKy_FilePath: this.anhChuKy_FilePath ? this.anhChuKy_FilePath : this.$route.params.id ? this.chiTietCanBo.anhChuKy_FilePath : '',
        anhChuKyNhay_FilePath: this.anhChuKyNhay_FilePath ? this.anhChuKyNhay_FilePath : this.$route.params.id ? this.chiTietCanBo.anhChuKyNhay_FilePath : '',
        headquarterId: this.form.headquarterId,
        buildingId: this.form.buildingId,
        maThe: this.form.maThe,
        ngayCapCCCD:  moment(
            new Date(this.convertStringToDateTime(this.form.ngayCapCCCD))
        ).toISOString(),
        ngayCapCMTND: moment(
            new Date(this.convertStringToDateTime(this.form.ngayCapCMTND))
        ).toISOString(),
        cccd: this.form.cccd,
        bit_DanhBa: this.form.bit_DanhBa,
        lockoutEnabled: this.form.lockoutEnabled
      };
    },
    onReset() {
      if (this.isEdit) {
        this.layChiTietCanBo();
      } else {
        this.form = {
          donVi: [],
          thongTinTaiKhoan: [],
          userId: null,
          tinhThanh: null,
          quanHuyen: null,
          phuongXa: null,
          maCanBo: "",
          hoTen: "",
          cA_Number: "",
          phone_DiDong: "",
          phone_CoQuan: "",
          phone_NhaRieng: "",
          email: "",
          gioiTinh: null,
          ngaySinh: null,
          cmtnd: "",
          diaChi: "",
          bit_NhanTinBuon_Email: false,
          bit_NhanTinBuon_SMS: false,
          bit_ThuTruongDonVi: false,
          thuTu: null,
          ngayCapCCCD: null,
          ngayCapCMTND: null,
          cccd: null,
        };
      }
    },
    onLuu() {
      let payload = this.getPayload();
      this.onSubmit(payload);
    },
    changeSwitch(data, index) {
      if (!data) this.resetMacDinhDonVi(index);
    },
    openModalConfirm(index, type, label) {
      this.labelDelete = label;
      this.indexSua = index;
      this.typeXoa = type;
      this.$refs["ModalConfirm"].$refs.confirm.show();
    },
    async onDelete() {
      this.isShowTaiKhoanTable = false;
      if (this.typeXoa == 1) {
        await this.form.donViList.splice(this.indexSua, 1);
      } else {
        await this.form.thongTinTaiKhoan.splice(this.indexSua, 1);
      }
      this.isShowTaiKhoanTable = true;
    },
    async themThongTinItem(data) {
      this.isShowTaiKhoanTable = false;
      await this.form.thongTinTaiKhoan.unshift(data);
      this.isShowTaiKhoanTable = true;
      this.$refs["ModalThemThongTinTaiKhoan"].hideModal();
    },
    themDonVi() {
      this.dataDonVi = null;
      // check mặc định để prefill
      if (
        this.form.donViList?.length === 0 ||
        this.form.donViList?.every((x) => !x.macDinh)
      ) {
        this.$refs["ModalThemThongTinDonVi"].showModal(true);
      } else {
        this.$refs["ModalThemThongTinDonVi"].showModal();
      }
    },
    suaDonViItem(data) {
      this.isShowCanBoTable = false;
      this.form.donViList.splice(this.indexSua, 1);
      this.form.donViList.unshift(data);
      if (data.macDinh) this.resetMacDinhDonVi(this.indexSua);
      this.$refs["ModalThemThongTinDonVi"].hideModal();
      this.isShowCanBoTable = true;
    },
    suaThongTinItem(data) {
      this.isShowTaiKhoanTable = false;
      this.form.thongTinTaiKhoan.splice(this.indexSua, 1);
      this.form.thongTinTaiKhoan.unshift(data);
      this.$refs["ModalThemThongTinTaiKhoan"].hideModal();
      this.isShowTaiKhoanTable = true;
    },
    onEditDonVi(data, index) {
      this.isLoad = !this.isLoad;
      this.dataDonVi = data;
      this.indexSua = index;
      this.$refs["ModalThemThongTinDonVi"].showModal();
    },
    onEditThongTin(data, index) {
      this.isLoad = !this.isLoad;
      this.dataDonVi = data;
      this.indexSua = index;
      this.isChooseTaiKhoan = data.tenDangNhap.userId ? true : false;
      this.$refs["ModalThemThongTinTaiKhoan"].$refs.ThongTinDonVi.show();
    },
    themThongTinTaiKhoan() {
      this.dataDonVi = null;
      this.isChooseTaiKhoan = false;
      this.$refs["ModalThemThongTinTaiKhoan"].$refs.ThongTinDonVi.show();
    },
    chonThongTinTaiKhoan() {
      this.dataDonVi = null;
      this.isChooseTaiKhoan = true;
      this.$refs["ModalThemThongTinTaiKhoan"].$refs.ThongTinDonVi.show();
    },
    resetMacDinhDonVi(index) {
      this.form.donViList.forEach((item) => {
        item.macDinh = false;
      });
      this.form.donViList[index].macDinh = true;
      this.keyTablePhamVi++;
    },
    themDonViItem(data) {
      this.isShowCanBoTable = false;
      this.form.donViList.unshift(data);
      if (data.macDinh) this.resetMacDinhDonVi(this.form.donViList.length - 1);
      this.$refs["ModalThemThongTinDonVi"].hideModal();
      this.isShowCanBoTable = true;
    },
    async layDiaChi(parantId = null, field = "listTinhThanh") {
      await this.$store.dispatch("common/layTinhThanh", {
        data: {
          parentId: parantId,
          level: parantId == null ? 1 : null,
        },
        onSuccess: (data) => {
          this[field] = data;
        },
      });
    },
    minDate(e) {
      let date = new Date("1900-01-01");
      return e < moment(date).toDate();
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    treeselectClass(valid) {
      return {
        "treeselect-invalid": valid,
      };
    },
    layDanhSachDonViCon() {
      return this.$store
        .dispatch("donVi/layDanhSachTheoDonViCha", {
          soCap: 999,
        })
        .then((res) => {
          if (res.data.succeeded) {
            this.optionsDonVi = res.data.data.map((item) => {
              return {
                Task_ID: item.id,
                Task_Parent_ID: item.iD_DonVi_Cha,
                Label: item.tenDonVi,
                Childrens: [],
                ...item,
              };
            });
            this.list_to_tree(this.optionsDonVi);
          } else {
            if (isInsert) {
              let getOption = this.optionsDonVi;
              getOption.forEach(function iter(a) {
                if (a.id == parentId) {
                  a.children = response.data.data;
                }
                Array.isArray(a.children) && a.children.forEach(iter);
              });

              this.optionsDonVi = getOption;
              this.reloadDonVI = !this.reloadDonVI;
            } else return response.data.data;
          }
        });
    },
    // layDanhSachDonViConBietPhai(parentId = null, level = 1, isInsert = false) {
    //   return this.$store
    //     .dispatch("donVi/layDanhSachTheoDonViCha", {
    //       idDonViCha: parentId,
    //       soCap: level,
    //     })
    //     .then((response) => {
    //       if (!parentId) {
    //         this.optionsDonViBietPhai = response.data.data;
    //       } else {
    //         if (isInsert) {
    //           let getOption = this.optionsDonViBietPhai;
    //           getOption.forEach(function iter(a) {
    //             if (a.id == parentId) {
    //               a.children = response.data.data;
    //             }
    //             Array.isArray(a.children) && a.children.forEach(iter);
    //           });

    //           this.optionsDonViBietPhai = getOption;
    //           this.reloadDonVIBietPhai = !this.reloadDonVIBietPhai;
    //         } else return response.data.data;
    //       }
    //     });
    // },
    layDanhSachChucVu() {
      this.$store.dispatch("chucVu/layDanhSachChucVu");
    },
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
      }
      return `data:image/png;base64,${window.btoa( binary )}`
    },
    layChiTietCanBo() {
      this.$store.dispatch("canBo/layChiTietCanBo", {
        id: this.$route.params.id,
      }).then((res) => {
        if(res.data.anhDaiDien_FilePath) {
          this.getAnhDaiDien_FilePath(res.data.anhDaiDien_FilePath)
        }
        if(res.data.anhChuKy_FilePath) {
          this.getAnhChuKy_FilePath(res.data.anhChuKy_FilePath)
        }
        if(res.data.anhChuKyNhay_FilePath) {
          this.getAnhChuKyNhay_FilePath(res.data.anhChuKyNhay_FilePath)
        }
        if(res.data.headquarterId) {
          this.form.headquarterId = res.data.headquarterId
        }
        if(res.data.buildingId) {
          this.form.buildingId = res.data.buildingId
        }
        if(res.data.maThe) {
          this.form.maThe = res.data.maThe
        }
        this.loadTruSo(res.data)
      })
    },
    getAnhDaiDien_FilePath(payload) {
      this.$store.dispatch('canBo/getImageUser',{path: payload}).then((res) => {
        this.form.anhDaiDien_FilePath = this._arrayBufferToBase64(res)
      })
    },
    getAnhChuKy_FilePath(payload) {
      this.$store.dispatch('canBo/getImageUser',{path: payload}).then((res) => {
        this.form.anhChuKy_FilePath = this._arrayBufferToBase64(res)
      })
    },
    getAnhChuKyNhay_FilePath(payload) {
      this.$store.dispatch('canBo/getImageUser',{path: payload}).then((res) => {
        this.form.anhChuKyNhay_FilePath = this._arrayBufferToBase64(res)
      })
    },
    async onSubmit(payload) {
      // this.getUserNameAndEmail();
      const isValid = await this.$refs.obCanBo.validate();
      const $vm = this;
      let data = payload;
      data = pickBy(data, function (value) {
        return !isNil(value);
      });
      data.thuTu = parseInt($vm.form.thuTu || 0);
      if (isValid) {
        this.isLoading = true;
        if (this.isEdit) {
          this.$store
            .dispatch("canBo/capNhatCanBo", {
              data: data,
              onSuccess: this.backToDetail,
            })
            .then((res) => {
              const dataLocal = JSON.parse(localStorage.getItem("userInfo"));
              if (res.data.data.data === dataLocal.id) {
                this.$store.dispatch("canBo/layThongTinCanBo").then((res) => {
                  localStorage.setItem(
                    "userInfo",
                    JSON.stringify(res.data.data)
                  );
                  window.location.reload();
                });
              }
              this.isLoading = false;
            })
            .catch((err) => {
              this.$toasted.clear();
              this.$toasted.global.showErrorMessage({
                message: err.data?.message || "Thao tác thất bại",
              });
              this.isLoading = false;
            });
        } else {
          this.$store
            .dispatch("canBo/taoCanBo", {
              data: data,
              onSuccess: this.backToList,
            })
            .then(() => {
              this.isLoading = false;
            })
            .catch((err) => {
              this.$toasted.clear();
              this.$toasted.global.showErrorMessage({
                message: err.data?.message || "Thao tác thất bại",
              });
              this.isLoading = false;
            });
        }
      }
    },

    loadOptionsDonVi({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        this.layDanhSachDonViCon(parentNode.id).then((data) => {
          parentNode.children = data;
          callback();
          this.$refs.chonCayDonVi.initialize(this.optionsDonVi);
        });
      }
    },
    loadOptionsDonViBietPhai({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        this.layDanhSachDonViConBietPhai(parentNode.id).then((data) => {
          parentNode.children = data;
          callback();
          this.$refs.chonCayDonViBietPhai.initialize(this.optionsDonViBietPhai);
        });
      }
    },
    format(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    convertStringToDateTime(stringDate) {
      if (stringDate) {
        const strDate = stringDate.split("/");
        return `${strDate[2]}-${strDate[1]}-${strDate[0]}`;
      }
    },
    backToDetail() {
      if (this.$route.name === ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.SUA) {
        this.$router.push({
          name: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.XEM,
          params: { id: this.$route.params.id },
        });
      } else if (
        this.$route.name ===
        ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG
      ) {
        this.$router.push({
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG,
          params: { id: this.$route.params.id },
        });
      }
    },
    backToList() {
      this.$router.push({
        name: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.NAME,
      });
    },
    async upLoadFileToServer(image, type, variable) {
      let payload = new FormData();
      payload.append("File", image);
      payload.append("ImageType", type);
      payload.append("Id", this.$route.params.id);
      await this.$store.dispatch("canBo/upload", {
        data: payload,
        onSuccess: (data) => {
          this.form[variable] = data.filePath;
        },
      }).then((res) => {
        if(variable === 'anhDaiDien_FilePath') {
          this.anhDaiDien_FilePath = res.data.data.filePath
          this.getAnhDaiDien_FilePath(res.data.data.filePath)
        }
        if(variable === 'anhChuKy_FilePath') {
          this.getAnhChuKy_FilePath(res.data.data.filePath)
          this.anhChuKy_FilePath = res.data.data.filePath
        }
        if(variable === 'anhChuKyNhay_FilePath') {
          this.getAnhChuKyNhay_FilePath(res.data.data.filePath)
          this.anhChuKyNhay_FilePath = res.data.data.filePath
        }
      }).catch((err) => {
        this.$toasted.global.showErrorMessage({
          message: `${err.response.data.message}`,
        });
      });
    },
    openCreateChucVu() {
      this.$refs["modalCapNhatChucVu"].$refs.modalCapNhatChucVu.show();
    },
    normalizer(node) {
      return {
        children: _isEmpty(node.children) ? undefined : node.children,
      };
    },
    selectClass(valid) {
      return {
        "select-invalid": valid,
      };
    },
    layNguoiDungKhongThuocCanBo() {
      this.$store.dispatch("user/layNguoiDungKhongThuocCanBo").then((res) => {
        this.danhSachNguoiDung = res.data.data;
      });
    },
    getUserNameAndEmail() {
      let nguoiDung = this.danhSachNguoiDung.filter(
        (x) => x.id === this.form.userId
      );
      if (_isEmpty(nguoiDung)) {
        this.form.email = "";
        this.form.userName = "";
      } else {
        this.form.email = nguoiDung[0].email || "";
        this.form.userName = nguoiDung[0].userName || "";
      }
    },
    list_to_tree(list) {
      if (list.length > 0) {
        var map = {},
          node,
          roots = [],
          i;
        for (i = 0; i < list.length; i += 1) {
          map[list[i].Task_ID] = i; // initialize the map
          list[i].Childrens = []; // initialize the children
        }
        for (i = 0; i < list.length; i += 1) {
          node = list[i];
          if (node.Task_Parent_ID !== this.guidEmpty) {
            // if you have dangling branches check that map[node.parentId] exists
            if (list[map[node.Task_Parent_ID]] != null) {
              list[map[node.Task_Parent_ID]].Childrens.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            } else {
              roots.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            }
          } else {
            roots.push({
              id: node.Task_ID,
              label: node.Label,
              parentId: node.Task_Parent_ID,
              children: node.Childrens,
            });
          }
        }
        return roots;
      }
      return list;
    },
    searchTree(element, matchingId) {
      if ((element || {}).id == matchingId) {
        return element;
      } else if (element.children != null) {
        let i;
        let result = null;
        for (i = 0; result == null && i < element.children.length; i++) {
          result = this.searchTree(element.children[i], matchingId);
        }
        return result;
      }
      return null;
    },
    async loadXa() {
      if (!this.form.quanHuyen) {
        this.form.phuongXa = null;
      } else {
        this.showXa = false;
        await this.layDiaChi(this.form.quanHuyen, "listPhuongXa");
        this.form.phuongXa = this.listPhuongXa[0].id;
        this.showXa = true;
      }
    },
    async loadHuyen() {
      if (!this.form.tinhThanh) {
        this.form.phuongXa = null;
        this.loadXa();
      } else {
        this.showXa = false;
        await this.layDiaChi(this.form.tinhThanh, "listPhuongXa");
        this.form.phuongXa = this.listPhuongXa[0].id;
        this.showXa = true;
        this.loadXa();
      }
    },

    loadToaNha() {
      this.listToaNha = this.listTruSo.find((item) => item.id === this.form.headquarterId).listBuilding || []
    },
    async getChiTiet() {
      this.form = _cloneDeep(this.chiTietCanBo);
      this.form.ngaySinh = this.form.ngaySinh
        ? moment(this.form.ngaySinh).format("YYYY-MM-DD")
        : null;
      this.ngaySinhFormatted = this.form.ngaySinh
        ? moment(this.form.ngaySinh).format("DD/MM/YYYY")
        : null;
      this.form.ngayCapCCCD = this.form.ngayCapCCCD
          ? moment(this.form.ngayCapCCCD).format("DD/MM/YYYY")
          : null;
      this.form.ngayCapCMTND = this.form.ngayCapCMTND
          ? moment(this.form.ngayCapCMTND).format("DD/MM/YYYY")
          : null;
      if (this.form.tinhId) {
        await this.layDiaChi();
        this.form.tinhThanh = this.form.tinhId;
      }

      if (this.form.xaId) {
        await this.layDiaChi(this.form.huyenId, "listPhuongXa");
        this.form.phuongXa = this.form.xaId;
      }
      if (this.form.huyenId) {
        await this.layDiaChi(this.form.tinhId, "listQuanHuyen");
        this.form.quanHuyen = this.form.huyenId;
      }
      this.form.donViList = [];
      this.form.departments.forEach((item) => {
        this.form.donViList.push({
          id: item.id,
          donVi: {
            id: item.donViId,
            label: item.recursiveName,
          },
          chucVu: {
            id: item.chucVuId,
            chucVu: item.tenChucVu,
          },
          trangThai: {
            id: item.trangThai == 1 ? true : false,
            macDinh: item.isDefault,
            name: item.trangThai == 1 ? "Hoạt động" : "Không hoạt động",
          },
          macDinh: item.isDefault,
          isShowTreeCCTC: item.isShowTreeCCTC,
          bit_LanhDaoDonVi: item.bit_LanhDaoDonVi,
        });
      });
      this.isShowTaiKhoanTable = false;
      this.form.thongTinTaiKhoan = [];
      this.form.userAccounts.forEach((item) => {
        let applications = [];
        item.applications.forEach((i) => {
          applications.push({
            name: i.applicationName,
            id: i.applicationId,
          });
        });
        this.form.thongTinTaiKhoan.push({
          tenDangNhap: {
            userId: item.userId,
            userName: item.userName,
            id: item.id,
            matKhau: item.password,
          },
          trangThai: {
            id: item.trangThai == 1 ? true : false,
            name: item.trangThai == 1 ? "Hoạt động" : "Không hoạt động",
          },
          ungDung: applications,
        });
      });
      this.isShowTaiKhoanTable = true;
    },
  },
  watch: {
    ngaySinhFormatted: {
      handler() {
        this.form.ngaySinh = this.form.ngaySinh
          ? this.convertStringToDateTime(this.ngaySinhFormatted)
          : null;
      },
    },
    chiTietCanBo: {
      async handler() {
        this.getChiTiet();
      },
    },
    "form.tinhThanh": async function (val) {
      if (!val) {
        this.form.quanHuyen = null;
      } else {
        this.showHuyen = false;
        await this.layDiaChi(val, "listQuanHuyen");
        this.form.quanHuyen = this.listQuanHuyen[0].id;
        this.showHuyen = true;
      }
    },
    "form.quanHuyen": async function (val) {
      if (!val) {
        this.form.phuongXa = null;
      } else {
        this.showXa = false;
        await this.layDiaChi(val, "listPhuongXa");
        this.form.phuongXa = this.listPhuongXa[0].id;
        this.showXa = true;
      }
    },
  },
};
</script>
<style lang="scss">
.mx-datepicker.is-danger {
  :focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgb(220 53 69 / 25%);
  }
  input {
    border: 1px solid #e42020;
  }
}
.error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  margin-bottom: 0;
}
.mx-datepicker {
  width: 100% !important;
  .mx-input {
    border-radius: 3px !important;
  }
}
.is-danger-custom {
  border: 1px solid red;
  border-radius: 3px;
}
.btn-chung.disabled {
  background-color: gray !important;
}
</style>
